/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Status of the rule
 */
export type DeviceModelIncidentRuleStatus = (typeof DeviceModelIncidentRuleStatus)[keyof typeof DeviceModelIncidentRuleStatus];

export const DeviceModelIncidentRuleStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ADMIN_DISABLED: 'admin_disabled',
} as const;
